export default __webpack_public_path__ + "static/media/icon-dilution-strength-diluted.e5ca514e.svg";